"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DappsFeatureFlags = void 0;
var DappsFeatureFlags;
(function (DappsFeatureFlags) {
    /**
     * Toggle between WC 1 and WC 2 to be ready for v1 sunset
     * @see https://medium.com/walletconnect/walletconnect-v1-0-sunset-notice-and-migration-schedule-8af9d3720d2e
     */
    DappsFeatureFlags["WalletConnectV2"] = "dapps-wallet-connect-v2";
})(DappsFeatureFlags = exports.DappsFeatureFlags || (exports.DappsFeatureFlags = {}));
